import { Controller } from "@hotwired/stimulus"
import { loadScript } from "../../../tilled_controller";
import { tick } from "svelte";

async function initChart() {
  return new Promise((resolve) => {
    if (window.ApexCharts) {
      resolve();
    } else {
      loadScript("https://cdn.jsdelivr.net/npm/apexcharts");
      let i = setInterval(() => {
        if (window.ApexCharts) {
          clearInterval(i);
          resolve();
        }
      }, 100);
    }
  });
}

function numberToCurrency(value) {
  return Number(value).toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
  }).split(".")[0];
}

export default class extends Controller {
  static values = {
    title: String,
    height: Number,
    series: Array, // {name, data}
  };

  connect = () => {
    initChart().then(() => {
      let series = this.seriesValue

      // ApexCharts requires all series to have the same number of data points or tooltips will only render for one or
      // the other. I'd rather the line just end, but this is the only way to get around it for now.
      for (let s of series) {
        while (s.data.length < 31) {
          const last = s.data[s.data.length - 1];
          s.data.push({x: last.x + 1, y: last.y});
        }
      }

      let chart = new ApexCharts(this.element, {
        chart: {
          type: 'line',
          height: this.heightValue,
          zoom: {
            type: 'x',
            enabled: true,
            autoScaleYaxis: true
          }
        },
        grid: {
          borderColor: "#444",
          clipMarkers: false,
          xaxis: {
            lines: {
              show: true

            },
          },
          yaxis: {
            lines: {
              show: true
            },
          },
        },
        title: {
          text: this.titleValue,
          align: 'left',
        },
        series: series,
        theme: {
          mode: 'dark'
        },
        yaxis: {
          min: 0,
          labels: {
            formatter: function(val, loa) {
              return numberToCurrency(val)
            },
          },
          format: function(val) {
            return numberToCurrency(val)
          },
          title: {
            text: 'Amount'
          },
          opposite: true,
        }
      })

      chart.render()
    })
  }
}
